var _circle, _circle2, _path, _circle3, _path2, _path3, _path4, _path5, _circle4, _path6, _circle5, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWishlist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_3",
    height: 512,
    viewBox: "0 0 64 64",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 51,
    r: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 41,
    r: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7 3h4v6h-4z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 31,
    r: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m17 3h4v6h-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m10 19h28v2h-28z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m45 8a1 1 0 0 0 -1-1h-1v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1-1v-3h-2v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1-1v-3h-2v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1-1v-3h-2v3a1 1 0 0 1 -1 1h-6a1 1 0 0 1 -1-1v-3h-1a1 1 0 0 0 -1 1v5h42z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m52.117 47 .75-6h-13.02l1 6z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 51,
    cy: 54,
    r: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m37 3h4v6h-4z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 54,
    r: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m27 3h4v6h-4z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m27 45c0-.338.032-.667.051-1h-9.051v-2h9.271a18.014 18.014 0 0 1 17.729-15v-12h-42v45a1 1 0 0 0 1 1h32.792a18.007 18.007 0 0 1 -9.792-16zm-3 3v2h-6v-2zm0-8h-6v-2h6zm4-6h-10v-2h10zm-10-4v-2h6v2zm-10-12a1 1 0 0 1 1-1h30a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-30a1 1 0 0 1 -1-1zm3 37a4 4 0 1 1 4-4 4 4 0 0 1 -4 4zm0-10a4 4 0 1 1 4-4 4 4 0 0 1 -4 4zm0-10a4 4 0 1 1 4-4 4 4 0 0 1 -4 4zm17 19h-10v-2h10z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m45 29a16 16 0 1 0 16 16 16.019 16.019 0 0 0 -16-16zm-5 22h11a3 3 0 1 1 -3 3 2.966 2.966 0 0 1 .184-1h-4.368a2.966 2.966 0 0 1 .184 1 3 3 0 0 1 -6 0 2.967 2.967 0 0 1 .4-1.471 2.99 2.99 0 0 1 .457-5.3l-1.704-10.229h-3.153v-2h4a1 1 0 0 1 .986.836l.528 3.164h14.486a1 1 0 0 1 .992 1.124l-1 8a1 1 0 0 1 -.992.876h-13a1 1 0 0 0 0 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWishlist);
export default __webpack_public_path__ + "static/media/wishlist.9cd370350f372bdab53df84b33c0b13a.svg";
export { ForwardRef as ReactComponent };